import {Button, Modal, ModalBody, ModalFooter, Input, FormGroup, Label, FormText} from "reactstrap";
import React, {useState, useEffect} from "react";
import {TextInputHook} from "hooks/text_input.hook";
import * as Commands from '../redux/settori.commands'
import {CSSTransition} from "react-transition-group";
import {useSelector} from 'react-redux'
import Select from "react-select";
import _ from "lodash";

export default function UpdateComponent(props) {

    const numero = TextInputHook(props.number);
    const descrizione = TextInputHook(props.description);
    const [submitError, setSubmitError] = useState(false);
    const [loading, setLoading] = useState(false);

    const [superiori, setSuperiori] = useState(_.get(props, 'officials', []));
    const utenti = useSelector(state => state.raiUtenti.data);

    const [contract, setContract] = useState(props.contract);

    const [orderCreationNotification, setOrderCreationNotification] = useState(utenti.filter(u => props.orderCreationNotification && props.orderCreationNotification.includes(u.email)));
    const [orderSignNotification, setOrderSignNotification] = useState(utenti.filter(u => props.orderSignNotification && props.orderSignNotification.includes(u.email)));


    const contracts = useSelector(state => state.contract.data);
    useSelector(state => state.customer.id);

    const Submit = async () => {
        setLoading(true);
        var res = await Commands.AggiornaSettore(props.id, descrizione.getValue(), contract.id, superiori, orderCreationNotification.map(item => item.email), orderSignNotification.map(item => item.email));

        setLoading(false);

        if (res.hasError) {
            setSubmitError(true);
            return;
        }

        clearForm();
        props.toggle();
    };

    const clearForm = () => {
        descrizione.clear();
        numero.clear();
    };


    useEffect(() => {

        if (submitError) {

            const timer = setTimeout(() => {
                setSubmitError(false);
            }, 3000);
            return () => clearTimeout(timer);
        }

    }, [submitError]);

    return (
        <Modal
            modalClassName="modal-black"
            isOpen={props.show}
            toggle={props.toggle}
        >
            <div className="modal-header justify-content-center">
                <button
                    aria-hidden={true}
                    className="close"
                    data-dismiss="modal"
                    type="button"
                    onClick={props.toggle}
                >
                    <i className="tim-icons icon-simple-remove"/>
                </button>
                <h6 className="title title-up">Modifica settore</h6>
            </div>
            <ModalBody>
                <form onSubmit={e => {
                    e.preventDefault();
                    Submit();
                }}>

                    <FormGroup>
                        <Label for="descrizione">Descrizione</Label>
                        <Input
                            {...descrizione.input}
                            name="descrizione"
                            id="descrizione"
                            placeholder="Inserisci descrizione"
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="superiori">Funzionari</Label>
                        <Select
                            className="react-select primary"
                            classNamePrefix="react-select"
                            placeholder="Seleziona superiori"
                            name="multipleSelect"
                            closeMenuOnSelect={false}
                            isMulti
                            value={superiori}
                            onChange={value =>
                                setSuperiori(value)
                            }
                            getOptionLabel={utente => utente.username}
                            getOptionValue={utente => utente.id}
                            options={[{
                                value: "",
                                description: "Superiori",
                                isDisabled: true
                            }, ...utenti]}

                        />
                        <FormText color="muted">
                            Funzionari settore
                        </FormText>

                    </FormGroup>


                    <FormGroup>
                        <Label for="superiori">Notifica creazione ordine</Label>
                        <Select
                            className="react-select primary"
                            classNamePrefix="react-select"
                            placeholder="Seleziona superiori"
                            name="multipleSelect"
                            closeMenuOnSelect={false}
                            isMulti
                            value={orderCreationNotification}
                            onChange={value => {
                                setOrderCreationNotification(value);
                            }
                            }
                            getOptionLabel={utente => utente.username}
                            getOptionValue={utente => utente.id}
                            options={[{
                                value: "",
                                description: "Destinatari",
                                isDisabled: true
                            }, ...utenti]}
                        />
                        <FormText color="muted">
                            Destinatari notifica creazione ordine
                        </FormText>

                    </FormGroup>

                    <FormGroup>
                        <Label for="superiori">Notifica firma ordine</Label>
                        <Select
                            className="react-select primary"
                            classNamePrefix="react-select"
                            placeholder="Seleziona superiori"
                            name="multipleSelect"
                            closeMenuOnSelect={false}
                            isMulti
                            value={orderSignNotification}
                            onChange={value =>
                                setOrderSignNotification(value)
                            }
                            getOptionLabel={utente => utente.username}
                            getOptionValue={utente => utente.id}
                            options={[{
                                value: "",
                                description: "Destinatari",
                                isDisabled: true
                            }, ...utenti]}

                        />
                        <FormText color="muted">
                            Destinatari notifica firma ordine
                        </FormText>

                    </FormGroup>


                    <FormGroup>
                        <Label for="contratto">Contratto</Label>
                        <Select
                            className="react-select primary"
                            classNamePrefix="react-select"
                            value={contract}
                            getOptionLabel={(item) => item.description}
                            onChange={value => {
                                setContract(value);
                            }}
                            options={[{
                                value: "",
                                description: "Contratto",
                                isDisabled: true
                            }, ...contracts]}
                            placeholder="Seleziona un contratto"
                        />
                        <FormText color="muted">
                            Contratto a cui si riferisce il settore
                        </FormText>
                    </FormGroup>
                    {/*Il button serve solo per permettere il submit del form con il pulsante enter */}
                    <button style={{display: 'none'}} type="submit"/>
                </form>
                <CSSTransition
                    in={submitError}
                    appear={true}
                    unmountOnExit
                    classNames="error"
                    timeout={300}
                >
                    <blockquote className="blockquote blockquote-danger">
                        <p className="mb-0 text-danger">Non è stato possibile salvare il settore.</p>
                    </blockquote>
                </CSSTransition>

            </ModalBody>
            <ModalFooter>
                <Button
                    color="danger"
                    data-dismiss="modal"
                    type="button"
                    onClick={props.toggle}
                >
                    Annulla
                </Button>
                <Button
                    color="primary"
                    type="button"
                    onClick={Submit}
                >
                    {loading ?
                        <i className="fa fa-spin fa-spinner"/>
                        : 'Salva'}
                </Button>
            </ModalFooter>
        </Modal>
    );

}
